import { Box, type BoxProps } from '@styled-system/jsx';

export const ShimmerBox = (props: BoxProps) => {
  return (
    <Box
      position="relative"
      overflow="hidden"
      _before={{
        content: "''",
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background:
          'linear-gradient(to right, #eff1f3 4%, #e2e2e2 25%, #eff1f3 36%)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '1000px 100%',
        animation: 'shimmer 2s linear infinite',
      }}
      {...props}
    />
  );
};
